import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideTeamModal, setTeamMode } from "../actions";

class TeamModal extends Component {

  constructor(props) {
    super(props);
    this.handleHideModal = this.handleHideModal.bind(this);
    this.handleTeamMode = this.handleTeamMode.bind(this);
  }

  handleHideModal() {
    this.props.hideTeamModal();
  }

  handleTeamMode() {
    this.props.setTeamMode();
  }

  render() {
    return (
      <div className="t-modal-backdrop">
        <div className="t-modal-box">
          <div className="t-modal-title">団体入稿について</div>
          <div className="t-modal-content">
            団体入稿を行うためには、あらかじめマイページから団体を作成する必要があります。<br />

          </div>
          <div className="t-modal-footer">
            <a className="btn btn-primary" href="/mypage/team">団体管理へ</a>
            <button className="btn btn-default" onClick={this.handleHideModal}>このままデザインを続ける</button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(f => f, {setTeamMode, hideTeamModal})(TeamModal);


// WEBPACK FOOTER //
// ./src/components/TeamModal.js